import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class ImpersonationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    /**
     * Impersonate a user by their email.
     * NOTE: Window must be refreshed after a successful response.
     */
    impersonateUser(targetUserEmail) {
        const url = this.urlsService.ACCOUNTS.IMPERSONATE_USER;
        const postParams = { target_user_email: targetUserEmail };
        return this.ajaxService.postFormEncodedDataObserveResponse(url, postParams);
    }
    /**
     * End impersonation.
     * NOTE: Window must be refreshed after a successful response if active user is changed.
     */
    endImpersonation() {
        const url = this.urlsService.ACCOUNTS.END_IMPERSONATION;
        return this.ajaxService.postFormEncodedDataObserveResponse(url, {});
    }
    getImpersonationMenu() {
        const url = this.urlsService.ACCOUNTS.IMPERSONATION_MENU;
        return this.ajaxService.getDataObserveBody(url);
    }
}
ImpersonationService.ɵfac = function ImpersonationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ImpersonationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
ImpersonationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ImpersonationService, factory: ImpersonationService.ɵfac, providedIn: 'root' });
